import { SmsService } from '../services/sms.service';
import { ValidatorService, EvalidatorRequire } from '../services/validator.service';

export class SmsModel {

    private _clientPrivateId: string = '';
    private _mobile: string          = '';
    private _message: string         = '';
    private _from: string;
    private _id: string;
    private _name: string = '';
    private _errors: any[];

    private _nbCharPerSMS: number = 149;
    private _priceperSMS: number  = 0.45;
    private _price: string = '0.00';


    //*************************************
    //************ CONSTRUCTOR ************
    //*************************************
    constructor(public smsService: SmsService) {
        this.calculatePrice();
    };

    //*************************************
    //*************** ACTION **************
    //*************************************
    public calculatePrice(){
        this._price = (Math.ceil(this.message.length / this._nbCharPerSMS) * this.priceperSMS).toFixed(2);
    }

    public send(){
        this.smsService.send(this);
    }

    //*************************************
    //************* VALIDATOR *************
    //*************************************
    public validate(): boolean {
        let validator = new ValidatorService();
        validator
            .addField(this.mobile, 'mobile', EvalidatorRequire.Require, [
                {fn: validator.phoneNumber, options: {}}
            ])
            .addField(this.message, 'message', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 1, max: 5000}},
            ]);
        this._errors = validator.run();
        return (this._errors == null);
    }

    //*************************************
    //************** METHOD ***************
    //*************************************


    //*************************************
    //********** GETTER / SETTER **********
    //*************************************

    get nbCharPerSMS(): number {
        return this._nbCharPerSMS;
    }

    get priceperSMS(): number {
        return this._priceperSMS;
    }

    get clientPrivateId(): string {
        return this._clientPrivateId;
    }

    set clientPrivateId(value: string) {
        this._clientPrivateId = value;
    }

    get mobile(): string {
        return this._mobile;
    }

    set mobile(value: string) {
        this._mobile = value;
    }

    get message(): string {
        return this._message;
    }

    set message(value: string) {
        this._message = value;
    }

    get from(): string {
        return this._from;
    }

    set from(value: string) {
        this._from = value;
    }

    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    get price(): string {
        return this._price;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get errors(): any[] {
        return this._errors;
    }

    set errors(value: any[]) {
        this._errors = value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/models/sms.model.ts